import { useEffect } from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';
import { API_CACHE_KEYS, API_PATHS } from '@/modules/common/constants';
import { useToast } from '@pw-tech/omni-ui';
import { getErrorMessage } from '@/modules/common/utils';
import { ApiClient } from '@pw-tech/web-sdk';

export const useGetRegistrationDetails = ({ enabled = true }: { enabled?: boolean }) => {
  const { toast: showToaster } = useToast();
  const { data, error, isFetching, refetch } = useQuery<any>({
    queryKey: [API_CACHE_KEYS.GET_REGISTRATION_DETAILS],
    queryFn: () => ApiClient.get(API_PATHS.GET_REGISTRATION_DETAILS),
    enabled,
  });

  useEffect(() => {
    if (error) {
      const errorMessage = getErrorMessage(error, 'Error in fetching registration details..');
      showToaster({
        message: errorMessage,
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center',
        },
      });
    }
  }, [error]);

  return {
    data: data?.data || null,
    error,
    isFetching,
    refetch,
  };
};

export const useUpdateRegistrationDetails = () => {
  const { toast: showToaster } = useToast();

  const { isLoading, isPending, error, mutate, mutateAsync } = useMutation(
    [API_CACHE_KEYS.UPDATE_REGISTRATION_DETAILS],
    (body: any) => {
      return ApiClient.patch(API_PATHS.UPDATE_REGISTRATION_DETAILS, body);
    }
  );

  useEffect(() => {
    if (error) {
      const errorMessage = getErrorMessage(error, 'Error in updating registration details..');
      showToaster({
        message: errorMessage,
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center',
        },
      });
    }
  }, [error]);

  return {
    error,
    isLoading,
    isPending,
    mutate,
    mutateAsync,
  };
};
